var map = {
	"./categories/accessories.svg": 206786,
	"./categories/bags.svg": 382113,
	"./categories/clothing.svg": 156304,
	"./categories/home-and-living.svg": 793509,
	"./categories/home-decor.svg": 182185,
	"./categories/paper.svg": 625458,
	"./categories/store.svg": 128835,
	"./categories/wall-art.svg": 302060,
	"./connect-store.svg": 424797,
	"./connect-store_inactive.svg": 898383,
	"./create-aluminum-print.svg": 96850,
	"./create-aluminum-print_inactive.svg": 818274,
	"./create-athletic-crop-top.svg": 628463,
	"./create-athletic-crop-top_inactive.svg": 406845,
	"./create-baby-youth-leggings.svg": 10237,
	"./create-baby-youth-leggings_inactive.svg": 744175,
	"./create-beanie.svg": 132046,
	"./create-beanie_inactive.svg": 638094,
	"./create-blanket.svg": 765699,
	"./create-blanket_inactive.svg": 342081,
	"./create-book.svg": 986965,
	"./create-book_inactive.svg": 335159,
	"./create-canvas-print.svg": 85376,
	"./create-canvas-print_inactive.svg": 431364,
	"./create-capris.svg": 164704,
	"./create-capris_inactive.svg": 847908,
	"./create-coaster.svg": 368289,
	"./create-coaster_inactive.svg": 477331,
	"./create-crewneck-sweatshirt.svg": 499833,
	"./create-crewneck-sweatshirt_inactive.svg": 226043,
	"./create-dad-cap-with-printed-patch.svg": 532707,
	"./create-dad-cap-with-printed-patch_inactive.svg": 811361,
	"./create-day-tote.svg": 860123,
	"./create-day-tote_inactive.svg": 598377,
	"./create-desk-mat.svg": 767756,
	"./create-desk-mat_inactive.svg": 501408,
	"./create-digital-art-print.svg": 736384,
	"./create-digital-art-print_inactive.svg": 177796,
	"./create-draped-kimono.svg": 455708,
	"./create-draped-kimono_inactive.svg": 654768,
	"./create-drawstring-bag.svg": 589614,
	"./create-drawstring-bag_inactive.svg": 630894,
	"./create-dress.svg": 789775,
	"./create-dress_inactive.svg": 637597,
	"./create-duvetcover.svg": 63349,
	"./create-duvetcover_inactive.svg": 31383,
	"./create-fabric.svg": 426353,
	"./create-fabric_inactive.svg": 767523,
	"./create-fine-art-print.svg": 13704,
	"./create-fine-art-print_inactive.svg": 241436,
	"./create-fitted-polo-shirt.svg": 706524,
	"./create-fitted-polo-shirt_inactive.svg": 190320,
	"./create-flare-dress.svg": 618444,
	"./create-flare-dress_inactive.svg": 756768,
	"./create-flare-skirt.svg": 874604,
	"./create-flare-skirt_inactive.svg": 523776,
	"./create-headband.svg": 306065,
	"./create-headband_inactive.svg": 549187,
	"./create-kimono.svg": 365451,
	"./create-kimono_inactive.svg": 505113,
	"./create-leggings.svg": 15958,
	"./create-leggings_inactive.svg": 190566,
	"./create-loose-tank-top.svg": 42379,
	"./create-loose-tank-top_inactive.svg": 21977,
	"./create-makeup-bag.svg": 508114,
	"./create-makeup-bag_inactive.svg": 720546,
	"./create-men-underwear.svg": 400238,
	"./create-men-underwear_inactive.svg": 321134,
	"./create-mini-shorts.svg": 169361,
	"./create-mini-shorts_inactive.svg": 797571,
	"./create-origami-tote.svg": 233019,
	"./create-origami-tote_inactive.svg": 948233,
	"./create-peignoir.svg": 508171,
	"./create-peignoir_inactive.svg": 137369,
	"./create-pencil-case.svg": 491174,
	"./create-pencil-case_inactive.svg": 758454,
	"./create-permanent-sticker.svg": 628098,
	"./create-permanent-sticker_inactive.svg": 286034,
	"./create-pet-bowl.svg": 13766,
	"./create-pet-bowl_inactive.svg": 668502,
	"./create-pillow-case.svg": 339058,
	"./create-pillow-case_inactive.svg": 583490,
	"./create-pillow.svg": 791625,
	"./create-pillow_inactive.svg": 633291,
	"./create-placemat.svg": 266379,
	"./create-placemat_inactive.svg": 830425,
	"./create-premium-drawstring-bag.svg": 8298,
	"./create-premium-drawstring-bag_inactive.svg": 434666,
	"./create-printed-patch.svg": 304677,
	"./create-printed-patch_inactive.svg": 458119,
	"./create-racerback-tank-top.svg": 333651,
	"./create-racerback-tank-top_inactive.svg": 649169,
	"./create-ruffle-scrunchie.svg": 701057,
	"./create-ruffle-scrunchie_inactive.svg": 806451,
	"./create-scarf.svg": 142361,
	"./create-scarf_inactive.svg": 155227,
	"./create-scoop-bralette.svg": 432126,
	"./create-scoop-bralette_inactive.svg": 715646,
	"./create-shirt-bellacanvas-3001.svg": 750798,
	"./create-shirt-bellacanvas-3001_inactive.svg": 53134,
	"./create-shirt-bellacanvas-6004.svg": 291012,
	"./create-shirt-bellacanvas-6004_inactive.svg": 948968,
	"./create-shorts.svg": 228711,
	"./create-shorts_inactive.svg": 313445,
	"./create-skirt.svg": 545071,
	"./create-skirt_inactive.svg": 220285,
	"./create-snapback-with-printed-patch.svg": 54624,
	"./create-snapback-with-printed-patch_inactive.svg": 799268,
	"./create-spiralnotebook.svg": 52238,
	"./create-spiralnotebook_inactive.svg": 216014,
	"./create-stainless-steel-tumbler.svg": 126662,
	"./create-stainless-steel-tumbler_inactive.svg": 124950,
	"./create-stainless-steel-water-bottle.svg": 843603,
	"./create-stainless-steel-water-bottle_inactive.svg": 746257,
	"./create-stationery-card.svg": 48487,
	"./create-stationery-card_inactive.svg": 331493,
	"./create-tablecloth.svg": 41642,
	"./create-tablecloth_inactive.svg": 573098,
	"./create-tank-top.svg": 626876,
	"./create-tank-top_inactive.svg": 187024,
	"./create-tapestry.svg": 899952,
	"./create-tapestry_inactive.svg": 728948,
	"./create-tea-towel.svg": 275230,
	"./create-tea-towel_inactive.svg": 768606,
	"./create-tote-bag.svg": 605453,
	"./create-tote-bag_inactive.svg": 132607,
	"./create-twilly-scarf.svg": 309723,
	"./create-twilly-scarf_inactive.svg": 251817,
	"./create-unisex-joggers.svg": 137778,
	"./create-unisex-joggers_inactive.svg": 451842,
	"./create-unisex-polo-shirt.svg": 281670,
	"./create-unisex-polo-shirt_inactive.svg": 445398,
	"./create-vegan-leather-backpack.svg": 669136,
	"./create-vegan-leather-backpack_inactive.svg": 428372,
	"./create-vegan-leather-crossbody-purse.svg": 236996,
	"./create-vegan-leather-crossbody-purse_inactive.svg": 301800,
	"./create-vegan-leather-makeup-bag.svg": 165630,
	"./create-vegan-leather-makeup-bag_inactive.svg": 615166,
	"./create-vegan-leather-placemat.svg": 8319,
	"./create-vegan-leather-placemat_inactive.svg": 44045,
	"./create-vegan-leather-tote-bag.svg": 932785,
	"./create-vegan-leather-tote-bag_inactive.svg": 910307,
	"./create-wall-art.svg": 467866,
	"./create-wall-art_inactive.svg": 347162,
	"./create-women-underwear.svg": 562336,
	"./create-women-underwear_inactive.svg": 676004,
	"./create-wood-print.svg": 774091,
	"./create-wood-print_inactive.svg": 48025,
	"./create-wrap-skirt.svg": 609020,
	"./create-wrap-skirt_inactive.svg": 440656,
	"./create-yoga-capris.svg": 721061,
	"./create-yoga-capris_inactive.svg": 975303,
	"./create-yoga-leggings.svg": 591280,
	"./create-yoga-leggings_inactive.svg": 802561,
	"./create-yoga-shorts.svg": 442438,
	"./create-yoga-shorts_inactive.svg": 714774,
	"./create-youth-leggings.svg": 136148,
	"./create-youth-leggings_inactive.svg": 983224,
	"./create-zipper-carry-all.svg": 447564,
	"./create-zipper-carry-all_inactive.svg": 94816,
	"./sell-product-one.svg": 965404,
	"./sell-product-one_inactive.svg": 100656,
	"./sell-product-ten.svg": 940909,
	"./sell-product-ten_inactive.svg": 695519,
	"./setup-payment.svg": 518581,
	"./setup-payment_inactive.svg": 415063,
	"./sync-product-one.svg": 646649,
	"./sync-product-one_inactive.svg": 635707,
	"./sync-product-ten.svg": 665848,
	"./sync-product-ten_inactive.svg": 434508
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 992127;